// extracted by mini-css-extract-plugin
module.exports = {"container":"videoimage_container__1we1x","icon_container":"videoimage_icon_container__r55Rh","icon_container_content":"videoimage_icon_container_content__2_8IA"};